<div class="rfe-wizard">

	<!-- En-tête : titre + fil d'étapes -->
	<div class="rfe-wizard-head">
		<h2 class="rfe-wizard-title h-reset">
			<svg width="1em" class="svg-middle rfe-wizard-title-icon" viewBox="0 0 384 512" aria-hidden="true" focusable="false">
				<use xlink:href="@Assets/svg/symbol-defs.svg#file-invoice" />
			</svg>
			{{ $t('vm.root.home.communication-rfe.title') }}
		</h2>

		<ol class="rfe-stepper">
			<li v-for="step in steps" :key="`rfe-step-${step.number}`" class="rfe-step" :class="stepStatus(step.number)">
				<span class="rfe-step-badge">
					<svg v-if="stepStatus(step.number) === 'is-done'" width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
						<use xlink:href="@Assets/svg/symbol-defs.svg#check" />
					</svg>
					<span v-else>{{ step.number }}</span>
				</span>
				<span class="rfe-step-label">{{ step.label }}</span>
			</li>
		</ol>
	</div>

	<!-- Corps : contenu de l'étape courante -->
	<div class="rfe-wizard-body">

		<!-- Étape 1 : Plateforme -->
		<div v-show="currentStep === 1" class="rfe-step-content">
			<div class="rfe-intro">
				<p>Chers utilisateurs,</p>

				<p>Dans le cadre de la Réforme de la Facturation Électronique (RFE), les entreprises devront utiliser une Plateforme Agréée (PA) pour l'émission et la réception de leurs factures électroniques.</p>

				<p>Nous vous proposons de sélectionner B2Brouter comme Plateforme Agréée afin de faciliter votre mise en conformité et de bénéficier des services associés à la réforme.</p>

				<p>La sélection de B2Brouter vous permettra également de souscrire au pack RFE et d'accéder aux fonctionnalités dédiées à la gestion de vos factures électroniques.</p>
			</div>

			<p class="rfe-question text-center"><strong>Souhaitez-vous choisir B2Brouter comme votre Plateforme Agréée ?</strong></p>

			<div class="choices">
				<radio-frame v-for="choice in choices" :key="`choice-${choice.value}`" :id="`choice-${choice.value}`" :name="`choice-group`"
							 v-model="selectedOption"
							 :radio-value="choice.value"
							 default-class="p-like"
				>
					<i18n v-if="choice.value === '1'" path="vm.components.popin.communication-rfe.choice.accept" tag="span">
						<a href="//osteo2ls.com/logiciel/assets/mentions-legales.pdf" target="_blank" rel="noopener noreferrer" :title="$t('vm.components.popin.communication-rfe.choice.link_title')">{{ $t("vm.components.popin.communication-rfe.choice.link") }}</a>
					</i18n>
					<span v-else>{{ choice.label }}</span>
				</radio-frame>
			</div>

			<!-- Refus : avertissement puis motif -->
			<div v-if="selectedOption === '0'" class="rfe-refuse-block">
				<div class="rfe-refuse-warning notice-warning">
					<p class="rfe-notice-line">
						<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
							<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
						</svg>
						<span>{{ $t('vm.components.popin.communication-rfe.recap.refuse-warning') }}</span>
					</p>
				</div>

				<div class="refuse-reason">
					<textarea-frame id="refuse-reason" v-model="refuseText" class="grid-item-full"
							 :label="$t('vm.components.popin.communication-rfe.refuse-reason.label')"
							 :placeholder="$t('vm.components.popin.communication-rfe.refuse-reason.placeholder')"
							 :title="$t('vm.components.popin.communication-rfe.refuse-reason.title')"
							 :errorTest="isRefuseReasonTooLong"
							 :errorMsg="message" />
				</div>
			</div>
		</div>

		<!-- Étape 2 : Remplaçants -->
		<div v-show="currentStep === 2" class="rfe-step-content">
			<h3 class="rfe-step-title h-reset">{{ $t('vm.components.popin.communication-rfe.substitutes.title') }}</h3>
			<p class="rfe-step-subtitle">{{ substituteStepSubtitle }}</p>

			<div class="rfe-sub-toolbar">
				<span class="rfe-sub-card-count">{{ $tc('vm.components.popin.communication-rfe.substitutes.selected-count', selectedSubstituteCount, { count: selectedSubstituteCount }) }}</span>
				<button type="button" class="btn btn-default rfe-sub-selectall" @click="toggleAllSubstitutes">
					{{ isAllSelected ? $t('vm.components.popin.communication-rfe.substitutes.unselect-all') : $t('vm.components.popin.communication-rfe.substitutes.select-all') }}
				</button>
			</div>

			<div v-for="office in officesWithSubstitute" :key="`rfe-office-${office.id}`" class="rfe-office">
				<p class="rfe-office-name">
					<svg width=".85em" class="svg-middle" viewBox="0 0 384 512" aria-hidden="true">
						<use xlink:href="@Assets/svg/symbol-defs.svg#map-marker-alt" />
					</svg>
					{{ office.name }}
				</p>

				<div class="rfe-sub-card">
					<div v-if="officesWithSubstitute.length > 1" class="rfe-sub-card-head">
						<span class="rfe-sub-card-count">{{ $tc('vm.components.popin.communication-rfe.substitutes.selected-count', officeSelectedCount(office), { count: officeSelectedCount(office) }) }}</span>
					</div>

					<div class="rfe-sub-card-body">
						<div v-for="substitute in substitutesOf(office)" :key="`rfe-sub-${office.id}-${substitute.id}`" class="rfe-sub-row">
							<checkbox-frame :id="`rfe-sub-${office.id}-${substitute.id}`"
											:value="isSubstituteSelected(office.id, substitute.id)"
											@input="toggleSubstitute(office.id, substitute.id, $event)"
											:title="substituteNameWithEmail(substitute)">
								<span class="rfe-sub-identity">
									<span class="rfe-sub-name">
										{{ substituteDisplayName(substitute) }}
										<span v-if="isSubstituteProfileIncomplete(substitute)" class="rfe-sub-badge-incomplete"
											  :title="$t('vm.components.popin.communication-rfe.substitutes.incomplete-profile-title')">
											<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true" focusable="false">
												<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
											</svg>
											{{ $t('vm.components.popin.communication-rfe.substitutes.incomplete-profile') }}
										</span>
									</span>
									<span class="rfe-sub-email">{{ substitute.email }}</span>
								</span>
							</checkbox-frame>

							<span class="rfe-sub-price">
								<span class="rfe-sub-price-amount">{{ formatAmount(substituteUnitPrice) }}</span>
								<span class="rfe-sub-price-note">{{ isAnnualSubscription ? $t('vm.components.popin.communication-rfe.substitutes.row-note-annual') : $t('vm.components.popin.communication-rfe.substitutes.row-note-monthly') }}</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Étape 3 : Récapitulatif (acceptation) -->
		<div v-show="currentStep === 3" class="rfe-step-content">

			<template v-if="selectedOption === '1'">
				<h3 class="rfe-step-title h-reset">{{ $t('vm.components.popin.communication-rfe.recap.accept-title') }}</h3>
				<p class="rfe-recap-pill">
					<svg width="1em" class="svg-middle" viewBox="0 0 448 512" aria-hidden="true">
						<use xlink:href="@Assets/svg/symbol-defs.svg#calendar-check" />
					</svg>
					{{ $t('vm.components.popin.communication-rfe.recap.start-pill', [prorataStartDateShort]) }}
				</p>

				<ul class="rfe-recap-lines">
					<li class="rfe-recap-line">
						<span class="rfe-recap-line-info">
							<span class="rfe-recap-line-title">{{ $t('vm.components.popin.communication-rfe.recap.line-holder') }}</span>
							<span class="rfe-recap-line-sub">{{ $t('vm.components.popin.communication-rfe.recap.line-holder-sub', [holderName]) }}</span>
						</span>
						<span class="rfe-recap-line-amount">
							<span class="rfe-recap-line-price">{{ formatAmount(substituteUnitPrice) }}</span>
							<span class="rfe-recap-line-tag">{{ $t('vm.components.popin.communication-rfe.recap.line-mandatory') }}</span>
						</span>
					</li>

					<li v-for="detail in selectedSubstituteDetails" :key="`rfe-recap-${detail.office.id}-${detail.substitute.id}`" class="rfe-recap-line">
						<span class="rfe-recap-line-info">
							<span class="rfe-recap-line-title">{{ $t('vm.components.popin.communication-rfe.recap.line-substitute', [substituteDisplayName(detail.substitute)]) }}</span>
							<span class="rfe-recap-line-sub">{{ $t('vm.components.popin.communication-rfe.recap.line-substitute-role') }}</span>
						</span>
						<span class="rfe-recap-line-amount">
							<span class="rfe-recap-line-price">{{ formatAmount(substituteUnitPrice) }}</span>
							<a href="#" class="rfe-recap-line-remove" @click.prevent="toggleSubstitute(detail.office.id, detail.substitute.id, false)">{{ $t('vm.components.popin.communication-rfe.recap.line-remove') }}</a>
						</span>
					</li>
				</ul>

				<div class="rfe-recap-summary">
					<div class="rfe-recap-summary-row">
						<span class="rfe-recap-summary-info">
							<span class="rfe-recap-summary-title">{{ isAnnualSubscription ? $t('vm.components.popin.communication-rfe.recap.next-invoice') : $t('vm.components.popin.communication-rfe.recap.monthly-line') }}</span>
							<span class="rfe-recap-summary-detail" v-if="isAnnualSubscription">{{ $t('vm.components.popin.communication-rfe.recap.next-invoice-detail-annual', [subscriptionEndDateShort, packsCountLabel]) }}</span>
							<span class="rfe-recap-summary-detail" v-else>{{ packsCountLabel }}</span>
						</span>
						<strong class="rfe-recap-summary-total">{{ formatAmount(nextInvoiceTotal) }}</strong>
					</div>
					<div class="rfe-recap-summary-row" v-if="isAnnualSubscription">
						<span class="rfe-recap-summary-title">{{ $t('vm.components.popin.communication-rfe.recap.recurring-annual') }}</span>
						<strong class="rfe-recap-summary-recurring">{{ formatAmount(recurringTotal) }}</strong>
					</div>
				</div>

				<p class="rfe-recap-note">
					<svg width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
						<use xlink:href="@Assets/svg/symbol-defs.svg#check-circle" />
					</svg>
					{{ $t('vm.components.popin.communication-rfe.recap.subscription-note') }}
				</p>
			</template>

		</div>

	</div>

	<!-- Pied : montant + navigation -->
	<div class="rfe-wizard-foot">
		<span class="rfe-wizard-amount">
			<template v-if="selectedOption === '1' && isLastStep">
				<span class="rfe-wizard-amount-label">{{ $t('vm.components.popin.communication-rfe.recap.foot-next-invoice', [packsCountLabel]) }}</span>
				<strong class="rfe-wizard-amount-value">{{ formatAmount(nextInvoiceTotal) }}</strong>
			</template>
			<span v-else-if="selectedOption === '0'" class="rfe-wizard-amount-label">{{ $t('vm.components.popin.communication-rfe.recap.no-amount') }}</span>
		</span>

		<div class="rfe-wizard-actions">
			<button-action v-if="!isFirstStep || canChooseLater" default-class="btn" btn-class="btn-default" :disabled="loading || submitted"
						   :title="backLabel" @click.native="back">
				{{ backLabel }}
			</button-action>

			<button-action v-if="!showConfirm" default-class="btn" btn-class="btn-info" :disabled="!canGoNext"
						   :title="nextLabel" @click.native="next">
				{{ nextLabel }}
				<svg width="1em" class="svg-middle" viewBox="0 0 320 512" aria-hidden="true" focusable="false">
					<use xlink:href="@Assets/svg/symbol-defs.svg#angle-right" />
				</svg>
			</button-action>

			<button-action v-else default-class="btn" btn-class="btn-info" :loading="loading || submitted"
						   :disabled="!canConfirm" :title="confirmLabel" @click.native="confirm">
				{{ confirmLabel }}
				<svg width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
					<use xlink:href="@Assets/svg/symbol-defs.svg#check" />
				</svg>
			</button-action>
		</div>
	</div>

</div>
